const baseUrl = process.env.baseUrl;


export default function ({ store, redirect }) {
    // If the user is authenticated redirect to home page
    if (store.getters['auth/loggedIn']) {
        return redirect('/')
    }
}
